import { usePhase } from "@/store/usePhase";
import { useDevice } from "@/store/useDevice";
import CurrentPhaseMobile from "./CurrentPhaseMobile";
import CurrentPhaseDescktop from "./CurrentPhaseDescktop";

const CurrentPhase = () => {
  const { currentPhase, tasks, completed, phaseStartDate } = usePhase();
  const { isMobile } = useDevice();

  if (isMobile) {
    return (
      <CurrentPhaseMobile
        currentPhase={currentPhase}
        tasks={tasks}
        completed={completed}
        phaseStartDate={phaseStartDate}
      />
    );
  }

  return (
    <CurrentPhaseDescktop
      currentPhase={currentPhase}
      tasks={tasks}
      completed={completed}
      phaseStartDate={phaseStartDate}
    />
  );
};

export default CurrentPhase;
